import React, { useState } from "react";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { CheckToken } from "../../login/AccessToken";
import { ChangeCursor } from "../../hlthtek-demo/components/MiscFunctions";
import axios from "axios";
import Navbar from "./Navbar";
import { Select, MenuItem, FormControl, InputLabel } from "@mui/material";
import { toast } from "react-toastify";
import {
  StyledSelect,
  StyledTooltip,
} from "../../doctor-console/StyledComponents";
import {
  TextField,
  Tooltip,
  Typography,
  Box,
  Grid,
  List,
  ListItem,
} from "@mui/material";

import Dropzone, { useDropzone } from "react-dropzone";
import Switch from "react-switch";
import ApiDatePickerField from "../../../components/date/ApiDatePickerField";
import StoreSelectField, { toStoresPayload } from "./StoreSelectField";

function DoctorsAddition({ updateList }) {
  const {
    register,
    watch,
    setValue,
    trigger,
    handleSubmit,
    formState: { errors },
    setError,
    getValues,
    control,
    reset,
  } = useForm();
  const qualificationsValue = watch("qualifications", "");
  const { onChange: onStateChange, ...stateRegisterRest } = register(
    "state",
    {},
  );

  const today = new Date().toISOString().split("T")[0];
  const [selectedFacility, setSelectedFacility] = useState(null);
  const [facilityId, setFacilityId] = useState([]);
  const [facilityList, setFacilityList] = useState([]);
  const [attachments, setAttachments] = useState(null);

  const handleFileSelect = (acceptedFiles) => {
    Promise.all(
      acceptedFiles.map((file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => {
            resolve({
              name: file.name,
              type: file.type,
              size: file.size,
              base64: reader.result,
            });
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      }),
    )
      .then((newAttachments) => {
        let newDetails = [...newAttachments];
        setAttachments(newDetails);
      })
      .catch((error) => {
        console.error("Error reading files:", error);
        // Handle error if needed
      });
  };

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : "",
  );
  const [accessToken, setAccessToken] = useState("");
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  // const [selectedUserTypes, setSelectedUserTypes] = useState([]);
  const [userList, setUserList] = useState([]);
  const [customerListForPartner, setCustomerListForPartner] = useState([]);
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const history = useHistory();
  const roleType = sessionStorage.getItem("roleType");
  const facilityName = sessionStorage.getItem("facility_name");
  const [currentUserType, setCurrentUserType] = useState("");
  const [departments, setDepartments] = useState([]);
  const [states, setStates] = useState("");
  const [cities, setCities] = useState([]);
  const [showTooltip, setShowTooltip] = useState(false);
  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_states/`, {
          headers: headers,
        })
        .then((res) => {
          setStates(res.data.state_list);
          console.log(res.data.state_list);
        });
    }
  }, [authToken]);

  const getStates = (stateName) => {
    console.log("stateName", stateName);
    var post_data = {
      state_name: stateName,
    };

    if (authToken !== "") {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_filtered_districts/`,
          JSON.stringify(post_data),
          {
            headers: headers,
          },
        )
        .then((res) => {
          console.log(res.data);
          setCities(res.data.district_list);
        });
    }
  };
  useEffect(() => {
    const accessToken = sessionStorage.getItem("accessToken");
    const roleType = sessionStorage.getItem("roleType");

    if (
      !accessToken
      //   ||
      //   (roleType !== "admin" &&
      //     roleType !== "facility admin" &&
      //     roleType !== "customer admin" &&
      //     roleType !== "partner admin" &&
      //     roleType !== "facility admin")
      //
    ) {
      history.push("/login");
    }
    getAllDepartments();
  }, []);

  const handleFacilityChange = (selectedValues) => {
    setSelectedFacility(selectedValues);
  };

  useEffect(() => {
    if (roleType === "facility admin") {
      getUserForAdmin();
    }
  }, [facilityId, roleType]);

  const getAllDepartments = () => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_departments/`, {
        headers: headers,
      })
      .then((res) => {
        setDepartments(res.data.department_list);
        console.log("data_user", res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserForAdmin = () => {
    let post_data;
    // post_data = {
    //     role_type: roleType,
    //     facility_id: facilityId,
    // };

    if (roleType === "admin") {
      post_data = {
        role_type: roleType,
        facility_id: selectedFacility,
      };
    } else if (roleType === "facility admin") {
      post_data = {
        role_type: roleType,
        facility_id: facilityId,
      };
    }
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}get_user_list_for_doctors_assistant/`,
        JSON.stringify(post_data),
        {
          headers: headers,
        },
      )
      .then((res) => {
        console.log("data_user", res.data);
        const filteredUserList = res.data.user_list.filter(
          (user) => !user.facility_admin,
        );
        console.log("filtered_data_user", filteredUserList);
        setUserList(filteredUserList);
      })
      .catch((err) => {
        console.log(err);
        toast.error(err);
      });
  };
  useEffect(() => {
    if (selectedFacility !== null) {
      getUserForAdmin();
    }
  }, [selectedFacility]);

  // useEffect(() => {
  //     getUserForAdmin();
  // }, []);

  useEffect(() => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_logged_in_user_info/`, {
        headers: headers,
      })
      .then((res) => {
        if (res.data.status === "Success") {
          console.log(res.data);

          setFacilityId(res.data.facility_id);
        }
      })
      .catch((err) => {
        console.log(err);
      });

    if (roleType === "admin" && Token()) {
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_facilities/`, {
          headers: headers,
        })
        .then((res) => {
          // if (res.data.status === "Success") {
          //   setFacilityList(res.data.facility_list);
          //   console.log("facility list test", res.data);
          // }
          if (res.data.status === "Success") {
            // Filter facilities with specific subscription types
            const filteredFacilities = res.data.facility_list.filter(
              (facility) =>
                facility.subscription_type ===
                "EHR/HMIS Service With ABDM Connector - HIU/HIP" ||
                facility.subscription_type ===
                "EHR/HMIS Service Without ABDM Connector",
            );
            setFacilityList(filteredFacilities);
            console.log("Filtered facility list", filteredFacilities);
          } else {
            console.log("facility list test", res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  }, []);

  const Token = () => {
    const check = CheckToken();
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };

  const onSubmit = (data, e) => {
    data.role = "doctor";
    data.user_type = "Doctor";
    data.salutation = data.salutation;
    data.multiple_fees = Boolean(data.multiple_fees);
    // add_new_user/ rejects an empty `stores` ("Store is required") and treats a
    // missing key as "leave the assignment alone", so it is sent only when set.
    const storeIds = toStoresPayload(data.stores);
    if (storeIds.length) {
      data.stores = storeIds;
    } else {
      delete data.stores;
    }
    const trimmedDateJoined = (data.date_joined || "").trim();
    if (!trimmedDateJoined) {
      data.date_joined = null; // avoid sending empty string to API
    } else {
      data.date_joined = trimmedDateJoined; // ensure plain YYYY-MM-DD string
    }
    const trimmedDob = (data.dob || "").trim();
    if (!trimmedDob) {
      data.dob = null; // avoid sending empty string to API
    } else {
      data.dob = trimmedDob;
    }
    // data.facility_id = 'HLTHTEK_DEV';
    if (Token() && roleType === "facility admin") {
      data.facility_id = facilityName;
    } else {
      data.facility_id = selectedFacility;
    }
    // console.log(data, "data");

    e.preventDefault();
    console.log(data);
    if (Token()) {
      data.doctor_signature = attachments || null;
      console.log("data", data);

      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}add_new_user/`,
          JSON.stringify(data),
          {
            headers: headers,
          },
        )
        .then((res) => {
          if (res.data.status === "Success") {
            toast.success("User Added !!");
            console.log(res);
            updateList();
          } else if (res.data.status === "Failed") {
            const message = res.data.message || "An unknown error occurred.";
            if (message.includes("corrupted")) {
              toast.error(
                "The Facility documents uploaded are corrupted. Please try with a different document.",
              );
            } else if (message.includes("Virus")) {
              toast.error(
                "The Facility documents uploaded has virus. Please try with a different document.",
              );
            } else if (message.includes("limit")) {
              reset();
              toast.error(message);
            } else {
              toast.error(message);
            }
          } else {
            toast.error("User Not Added !! Try again later");
            console.log("checcking..", res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          toast.error(err);
        });
    }
  };
  return (
    <div>
      {/* <Navbar /> */}

      <div className="col-sm-12 col-md-12 col-lg-10" style={{ margin: "auto" }}>
        <div className="contact-panel mb-50" style={{ marginTop: "50px" }}>
          {/* <h4 style={{ textAlign: "left" }}>Add New Doctor</h4> */}

          <div style={{ marginBottom: "20px" }}>
            {/* Row 1: Title */}

            {/* Row 2: Grid for Button + Image */}
            <Grid
              container
              alignItems="center"
            // style={{ marginTop: "15px", padding: "0 5%" }}
            >
              {/* Button (left, takes 4/12 = 1/3 width) */}
              <Grid item xs={6}>
                {/* {!showFind && (
                <Link
                  href="#"
                  onClick={(event) => {
                    if (healthIdDetails) {
                      event.preventDefault();
                    } else {
                      handleFindClick();
                    }
                  }}
                  className="btn btn__secondary hyperlink search-edit-patient-btn"
                  style={{
                    pointerEvents: healthIdDetails ? "none" : "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  Search/Edit Patient
                </Link>
              )} */}
                <h4 style={{ textAlign: "left" }}>Add New Doctor</h4>
              </Grid>

              {/* Empty spacer (middle, takes 2/12 = pushes image to 2/3 position) */}
              <Grid item xs={2}></Grid>

              {/* Profile Image (placed at 2/3 of width) */}
              <Grid item xs={4} style={{ textAlign: "left" }}>
                <img
                  src="/assets/images/newIcons/patienticon.svg"
                  alt="Profile"
                  style={{
                    width: "clamp(60px, 15vw, 120px)",
                    height: "auto",
                    borderRadius: "50%",
                    marginLeft: "40px",
                    objectFit: "cover",
                  }}
                />
              </Grid>
            </Grid>
          </div>

          <form
            className="contact-panel__form"
            onSubmit={handleSubmit(onSubmit)}
          >
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <h5 style={{ textAlign: "left", marginBottom: "16px" }}>
                  Doctor Details
                </h5>
              </div>
              <div
                className="col-sm-6 col-md-6 col-lg-6"
                style={{ marginBottom: "16px" }}
              />
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="salutation" className="required-label">
                  Salutation
                </label>
                <div className="form-group">
                  <i className="icon-user form-group-icon"></i>
                  <select
                    className="form-control"
                    name="salutation"
                    {...register("salutation", {})}
                  >
                    <option value="">Select Salutation</option>
                    {[
                      "Mr.",
                      "Mrs.",
                      "Ms.",
                      "Miss",
                      "Dr.",
                      "Prof.",
                      "Prof. Dr.",
                      "Master",
                      "Rev",
                      "Mx",
                    ].map((title) => (
                      <option key={title} value={title}>
                        {title}
                      </option>
                    ))}
                  </select>
                  {errors.salutation && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.salutation.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="username" className="required-label">
                    User Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter User Name"
                    name="username"
                    {...register("username", {
                      required: "User Name is required.",
                    })}
                    autoComplete="off"
                  />
                  {errors.username && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.username.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="first_name" className="required-label">
                    First Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter First Name"
                    name="first_name"
                    {...register("first_name", {
                      required: "First Name is required.",
                    })}
                  />
                  {errors.first_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.first_name.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="password" className="required-label">
                  Password{" "}
                </label>
                <div className="form-group">
                  <i className="icon-news form-group-icon"></i>
                  <StyledTooltip
                    open={showTooltip}
                    title={
                      <Box
                        sx={{
                          backgroundColor: "#21cdc0",
                          p: 2,
                          borderRadius: "8px",
                          boxShadow: "0px 0px 0px white",
                          border: "none",
                        }}
                      >
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: "bold", color: "#fff" }}
                        >
                          Password requirements
                        </Typography>
                        <List sx={{ color: "#fff" }}>
                          <ListItem>An alphabet</ListItem>
                          <ListItem>A number</ListItem>
                          <ListItem>A special character</ListItem>
                          <ListItem>Minimum 8 characters</ListItem>
                        </List>
                      </Box>
                    }
                    arrow
                    placement="right"
                  >
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Enter Password"
                      name="password"
                      {...register("password", {
                        required: "Password is required.",
                      })}
                      autoComplete="off"
                      onFocus={() => setShowTooltip(true)}
                      onBlur={() => setShowTooltip(false)}
                    />
                  </StyledTooltip>
                  {errors.password && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.password.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="last_name" className="required-label">
                    Last Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Last Name"
                    name="last_name"
                    {...register("last_name", {
                      required: "Last Name is required.",
                    })}
                  />
                  {errors.last_name && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.last_name.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="fees" className="required-label">
                    Fees
                  </label>
                  <input
                    type="number"
                    className="form-control"
                    placeholder="Enter Fees"
                    name="fees"
                    min="0"
                    max="5000"
                    {...register("fees", {
                      required: "Fees is required.",
                      min: {
                        value: 0,
                        message: "Fees must be at least 0.",
                      },
                      max: {
                        value: 5000,
                        message: "Fees must be no more than 5000.",
                      },
                    })}
                    autoComplete="off"
                  />
                  {errors.fees && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.fees.message}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="department" className="required-label">
                    Department
                  </label>
                  <select
                    className="form-control"
                    name="department"
                    {...register("department", {
                      required: "department is required.",
                    })}
                  >
                    <option value="">Select Department</option>
                    {departments.map((department, index) => (
                      <option key={index} value={department.department}>
                        {department.department}
                      </option>
                    ))}
                  </select>
                  {errors.department && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.department.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="multiple_fees">Multiple Fees</label>
                  <div>
                    <Controller
                      name="multiple_fees"
                      control={control}
                      defaultValue={false}
                      render={({ field }) => (
                        <Switch
                          id="multiple_fees"
                          checked={Boolean(field.value)}
                          onChange={field.onChange}
                          handleDiameter={15}
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="phone_no" className="required-label">
                    Phone No.
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Phone Number"
                    name="phone_no"
                    {...register("phone_no", {
                      required: "Phone Number is required.",
                    })}
                  />
                  {errors.phone_no && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.phone_no.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6" />
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="email" className="required-label">
                    Email
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Email"
                    name="email"
                    {...register("email", {
                      required: "Email is required.",
                      pattern: {
                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                        message: "Invalid email address",
                      },
                    })}
                  />
                  {errors.email && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.email.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6" />
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="qualifications" className="required-label">
                    Qualification
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Qualifications"
                    name="qualifications"
                    maxLength={170}
                    {...register("qualifications", {
                      required: "Qualifications is required.",
                      maxLength: {
                        value: 170,
                        message: "Maximum 170 characters allowed.",
                      },
                    })}
                    onChange={(e) => {
                      setValue("qualifications", e.target.value);
                      trigger("qualifications");
                    }}
                  />
                  <div
                    style={{
                      textAlign: "right",
                      fontSize: "12px",
                      color: "#6c757d",
                      marginTop: "4px",
                    }}
                  >
                    {(qualificationsValue || "").length}/170
                  </div>
                  {errors.qualifications && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.qualifications.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6" />
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="specialization" className="required-label">
                    Specialization
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Specialization"
                    name="specialization"
                    {...register("specialization", {
                      required: "Specialization is required.",
                    })}
                  />
                  {errors.specialization && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.specialization.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6" />
            </div>
            <div className="row">
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="registration_no" className="required-label">
                    Medical Registration No
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Medical Registration No"
                    name="registration_no"
                    {...register("registration_no", {
                      required: "Registration Number is required.",
                    })}
                  />
                  {errors.registration_no && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.registration_no.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6" />
            </div>

            <div className="row" style={{ marginTop: "8px" }}>
              <div className="col-12">
                <h5 style={{ textAlign: "left", marginBottom: "16px" }}>
                  Other Details
                </h5>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="dob">Date of Birth</label>
                  <div className="form-group form-group-date">
                    <Controller
                      name="dob"
                      control={control}
                      render={({ field }) => (
                        <ApiDatePickerField
                          id="dob"
                          value={field.value || ""}
                          onChange={field.onChange}
                          className="form-control"
                        />
                      )}
                    />
                  </div>
                  {errors.dob && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.dob.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="date_joined">Practice started since</label>
                  <div className="form-group form-group-date">
                    <Controller
                      name="date_joined"
                      control={control}
                      render={({ field }) => (
                        <ApiDatePickerField
                          id="date_joined"
                          value={field.value || ""}
                          onChange={field.onChange}
                          className="form-control"
                        />
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="gender">Gender</label>
                  <select
                    className="form-control custom-select-style"
                    placeholder="Select Gender"
                    name="gender"
                    {...register("gender", {})}
                  >
                    <option value="">Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="other">Other</option>
                  </select>
                  {errors.gender && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.gender.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="address">Address</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Address"
                    name="address"
                    {...register("address", {})}
                  />
                  {errors.address && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.address.message}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="state">States</label>
                <select
                  className="form-control"
                  {...stateRegisterRest}
                  onChange={(e) => {
                    onStateChange(e);
                    getStates(e.target.value);
                  }}
                >
                  <option value="">Select State</option>
                  {states &&
                    states.map((state, index) => (
                      <option
                        key={index}
                        value={state.state_name.toLowerCase()}
                      >
                        {state.state_name}
                      </option>
                    ))}
                </select>
                {errors.state && (
                  <p className="errorMsg" style={{ color: "red" }}>
                    {errors.state.message}
                  </p>
                )}
              </div>
              <div className="col-sm-6 col-md-6 col-lg-6">
                <label htmlFor="city">City</label>
                <div className="form-group">
                  <select
                    className="form-control"
                    name="city"
                    {...register("city", {})}
                  >
                    <option value="">Select City</option>
                    {cities.map((city, index) => (
                      <option
                        key={index}
                        value={city.district_name.toLowerCase()}
                      >
                        {city.district_name}
                      </option>
                    ))}
                  </select>
                  {errors.city && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.city.message}
                    </p>
                  )}
                </div>
              </div>
              <StoreSelectField control={control} />

              {roleType === "admin" && (
                <div className="col-sm-6 col-md-6 col-lg-6">
                  <div className="form-group">
                    <label htmlFor="facility_id" className="required-label">
                      Select a Facility{" "}
                    </label>
                    <FormControl fullWidth>
                      <Controller
                        name="facility_id"
                        control={control}
                        defaultValue=""
                        rules={{ required: "Facility is required." }}
                        render={({ field }) => (
                          <StyledSelect
                            fullWidth
                            {...field}
                            className="form-control "
                            labelId="facility-select-label"
                            id="facility-select"
                            onChange={(e) => {
                              field.onChange(e);
                              handleFacilityChange(e.target.value);
                            }}
                          >
                            {facilityList.map((facility) => (
                              <MenuItem
                                key={facility.facility_id}
                                value={facility.facility_id}
                              >
                                {facility.facility_name}
                              </MenuItem>
                            ))}
                          </StyledSelect>
                        )}
                      />
                    </FormControl>
                  </div>
                </div>
              )}
              <div className="col-sm-6 col-md-6 col-lg-6">
                <div className="form-group">
                  <label htmlFor="assistant" className="required-label">
                    Select Assistant(s)
                  </label>
                  <FormControl fullWidth>
                    <Controller
                      name="assistant"
                      control={control}
                      defaultValue={[]}
                      rules={{
                        required: "At least one assistant is required.",
                      }}
                      render={({ field }) => (
                        <StyledSelect
                          className="form-control "
                          {...field}
                          labelId="assistant-select-label"
                          id="assistant-select"
                          multiple
                        >
                          {userList.map((user) => (
                            <MenuItem key={user.id} value={user.id}>
                              {user.username}
                            </MenuItem>
                          ))}
                        </StyledSelect>
                      )}
                    />
                  </FormControl>
                </div>
              </div>

              <div
                className="col-sm-6 col-md-6 col-lg-6"
                style={{ marginTop: "10px" }}
              >
                <div className="form-group">
                  <label htmlFor="doctor_signature">Doctor Signature</label>
                  <Controller
                    name="doctor_signature"
                    control={control}
                    defaultValue={[]}
                    rules={{
                      validate: (files) => {
                        if (!files || files.length === 0) return true;
                        const file = files[0];

                        if (file.size < 20 * 1024) {
                          // Minimum file size: 20 KB
                          return "File size must be at least 20KB.";
                        }
                        if (file.size > 2 * 1024 * 1024) {
                          // Maximum file size: 2 MB
                          return "File size must not exceed 2MB.";
                        }
                        return true;
                      },
                    }}
                    render={({ field }) => (
                      <div>
                        {field.value && field.value.length > 0 ? (
                          <div
                            style={{
                              position: "relative",
                              width: "40%",
                              height: "30%",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={URL.createObjectURL(field.value[0])}
                              alt="Uploaded Signature"
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "contain",
                              }}
                            />
                            <button
                              type="button"
                              style={{
                                position: "absolute",
                                top: "5px",
                                right: "5px",
                                background: "red",
                                color: "white",
                                border: "none",
                                borderRadius: "50%",
                                width: "20px",
                                height: "20px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                              onClick={() => field.onChange([])}
                            >
                              &times;
                            </button>
                          </div>
                        ) : (
                          <Dropzone
                            onDrop={(acceptedFiles) => {
                              handleFileSelect(acceptedFiles); // Call handleFileSelect
                              field.onChange(acceptedFiles); // Keep React Hook Form in sync
                            }}
                            maxFiles={1}
                            accept={{
                              "image/*": [".jpeg", ".jpg", ".png"],
                            }}
                          >
                            {({ getRootProps, getInputProps }) => (
                              <div
                                {...getRootProps({
                                  className: "dropzone",
                                  style: {
                                    border: "2px dashed #ccc",
                                    padding: "3px",
                                    cursor: "pointer",
                                  },
                                })}
                              >
                                <input {...getInputProps()} />
                                <p style={{ margin: 0 }}>
                                  Drag & drop a file here, or click to select a
                                  file
                                </p>
                              </div>
                            )}
                          </Dropzone>
                        )}

                        {errors.doctor_signature && (
                          <p className="errorMsg" style={{ color: "red" }}>
                            {errors.doctor_signature.message}
                          </p>
                        )}
                        {/* <p>
                          The file should be an image(jpeg/jpg/png) ranging
                          between 20KB and 2MB
                        </p> */}
                      </div>
                    )}
                  />
                </div>
              </div>

              <div
                className="col-sm-3 col-md-3 col-lg-3"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginTop: "3.9%",
                }}
              >
                <div className="form-group">
                  <div class="form-check">
                    <input
                      type="checkbox"
                      class="form-check-input"
                      placeholder="Active"
                      name="active"
                      {...register("active")}
                    />
                    <label class="form-check-label" for="flexRadioDefault2">
                      Active
                    </label>
                  </div>
                  {errors.active && (
                    <p className="errorMsg" style={{ color: "red" }}>
                      {errors.active.message}
                    </p>
                  )}
                </div>
              </div>
              <div
                className="col-sm-3 col-md-3 col-lg-3"
                style={{ marginTop: "1.02%" }}
              >
                <button
                  type="submit"
                  className="btn btn__secondary btn__rounded btn__block btn__xhight mt-10"
                >
                  <span>Add Doctor</span> <i className="icon-arrow-right"></i>
                </button>
                <div className="contact-result"></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default DoctorsAddition;
